import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ANPR_PERSON_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface StationListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (station?: string, item?: ItemVM) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

type Key = {
  codice: string;
};

interface Station {
  key: Key;
  descrizione: string;
}

const StationListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Postazione',
  id = 'station',
}: StationListComponentProps): React.ReactElement => {
  const [station] = useHttpFetch<HttpResponseList<Station>, Array<ItemVM>>(
    `${__ANPR_PERSON_API_URL__}/professione`,
    {
      onBootstrap: true,
      initialData: [],
      transformer: (response: AxiosResponse<HttpResponseList<Station>>) => {
        const { data } = response;

        return data?.payload.list.map((item) => ({
          id: item.key.codice,
          value: item.descrizione,
        })) as Array<ItemVM>;
      },
    }
  );

  const list = (station.data as Array<ItemVM>) || [];

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          const item = list.find((element) => element.id === selectedValue);
          onChange(selectedValue, item);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

StationListComponent.displayName = 'Station List component';

const StationList = memo(StationListComponent);

export default StationList as typeof StationListComponent;
